import classNames from "classnames";
import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

import logoSrc from "../../../assets/images/logo.svg";
import logoInvertedSrc from "../../../assets/images/logo-inverted.svg";

const Header = styled.h1`
  ${tw`m-0 pl-[2px]`}
`;

const LogoImage = styled.img`
  transition: filter 250ms ease-in-out;

  &.logo-white {
    filter: brightness(0) invert(1);
  }

  body:not(.scrolled) &.logo-white-at-top {
    filter: brightness(0) invert(1);
  }
`;

export enum LogoColor {
  Default = 0,
  Invert,
  White,
  WhiteAtTop,
}

interface LogoProps {
  color?: LogoColor;
  width?: number;
  height?: number;
}

const Logo: React.FunctionComponent<LogoProps> = ({
  color = LogoColor.Default,
  width = 175,
  height = 30,
}) => (
  <Header>
    <Link to="/">
      <LogoImage
        src={color === LogoColor.Invert ? logoInvertedSrc : logoSrc}
        alt="ProsperStack"
        width={width}
        height={height}
        className={classNames(
          color === LogoColor.White && "logo-white",
          color === LogoColor.WhiteAtTop && "logo-white-at-top"
        )}
      />
    </Link>
  </Header>
);

export default Logo;
